// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"561c65b77fdb8ccdfe86","293":"fad0d71092011b4ac127","518":"f7edf15af219f8050c59","779":"dea97f8a35cdfc967260"}[chunkId] + ".js";
};